export function getFeaturedImage(post, size, fallback) {
    try {
        const image = post._embedded['wp:featuredmedia'][0];
        if (size && image.media_details && image.media_details.sizes && image.media_details.sizes[size]) {
            return image.media_details.sizes[size].source_url;
        } else {
            return image.source_url;
        }
    } catch (e) {
        return fallback;
    }
}



// WEBPACK FOOTER //
// ./src/util/FeaturedImage.js